export enum SortDirectionEnum {
    Ascending = 0,
    Descending = 1
}
